var _circle, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "white",
    stroke: "#C8D1D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5958 10.0264H4.4519V10.6701H12.5958V10.0264Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5958 11.3135H4.4519V11.9572H12.5958V11.3135Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5958 12.6003H4.4519V13.2441H12.5958V12.6003Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5958 9.30466H12.0158V5.61804L8.50482 3.71145L5.03191 5.874V9.29257H4.4519V5.51203L8.48578 3L12.5958 5.23189V9.30466Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2839 9.29239H10.7039V6.56592L8.5145 5.37722L6.3438 6.72917V9.28433H5.76379V6.3672L8.49584 4.66577L11.2839 6.17976V9.29239Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97119 9.23473H9.39119V7.66793L8.52455 7.19753L7.65642 7.73807V9.2311H7.07642V7.3761L8.50552 6.48608L9.97119 7.28178V9.23473Z",
    fill: "#CFCFCF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.32654,
    y1: 11.8418,
    x2: 13.5735,
    y2: 11.8418,
    stroke: "#87BCBF",
    strokeWidth: 0.1,
    strokeDasharray: "2 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75677 11.799C3.35904 11.799 3.19995 11.7007 3.19995 11.7007V13.5001H13.7V11.7007C13.7 11.3525 12.4272 11.8644 12.4272 11.8644C12.4272 11.8644 11.8065 11.8168 11.118 11.7007C10.4295 11.5846 9.88177 11.8644 9.88177 11.8644C9.88177 11.8644 9.00677 11.537 8.44995 11.7007C7.89313 11.8644 7.73404 11.799 7.73404 11.799C7.73404 11.799 6.73907 11.5846 6.22268 11.7007C5.70628 11.8168 4.94995 11.8644 4.94995 11.8644C4.94995 11.8644 4.1545 11.799 3.75677 11.799Z",
    fill: "#279898",
    fillOpacity: 0.41
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcIcon);
export default __webpack_public_path__ + "static/media/ecIcon.aa225ea7e655ce610239c8b9010385a9.svg";
export { ForwardRef as ReactComponent };